export default __webpack_public_path__ + "static/media/activity-link.acfde141.svg";